export enum QuantityInfoType {
  INFO = "INFO",
  STOCK_ERROR = "STOCK_ERROR",
  QTY_ERROR = "QTY_ERROR",
  SUCCESS = "SUCCESS",
}
